import React, { useEffect, useMemo, useState, useRef } from "react";
import Modal from "components/base/Modal";
import css from "./style.scss";
import Table, { Column } from 'components/base/Table';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { fromJS, Map } from "immutable";
import CloseBlack from '../../../assets/images/CloseBlack.svg';
import numberToPrice from 'utils/currency/numberToPrice';
import formatDate from 'utils/date/formatDate';
import numberFormat from 'utils/number/format';
import stopPropagation from 'utils/DOM/propagation';
import Auction from "../../../assets/images/auction.svg";
import OnMarket from "../../../assets/images/mls.svg";
import PreForeclosures from "../../../assets/images/pre-foreclosures.svg";
import BankOwned from "../../../assets/images/bank-owned.svg";
import CashBuyers from "../../../assets/images/cash-buyer.svg";
import Liens from "../../../assets/images/liens.svg";
import Vacant from "../../../assets/images/vacant.svg";
import HighEquity from "../../../assets/images/high-equity.svg";
import Bankruptcy from "../../../assets/images/bankruptcy.svg";
import Divorce from "../../../assets/images/divorce.svg";
import FailedListings from "../../../assets/images/failedListings.svg";
import Flippers from "../../../assets/images/flippers.svg";
import FreeClear from "../../../assets/images/free-and-clear.svg";
import PreProbate from "../../../assets/images/pre-probate.svg";
import SeniorOwners from "../../../assets/images/senior-owners.svg";
import TaxDelinquency from "../../../assets/images/tax-delinquency.svg";
import TiredLandlords from "../../../assets/images/tired-landlords.svg";
import UpsideLand from "../../../assets/images/upside-down.svg";
import VacantLand from "../../../assets/images/SearchVacantIcon.svg";
import ZombieProperties from "../../../assets/images/zombie-properties.svg";

import BedIcon from '../../../assets/images/Bed.svg';
import Bath from '../../../assets/images/Bath.svg';
import LotSize from '../../../assets/images/LotSize.svg';
import SqFt from '../../../assets/images/SqFt.svg';


//PropertyTypeIcons
import ResidentialIcon from '../../../assets/images/ResidentialIcon.svg';
import CommercialIcon from '../../../assets/images/CommercialIcon.svg';
import OfficeIcon from '../../../assets/images/OfficeIcon.svg';
import IndustrialIcon from '../../../assets/images/IndustrialIcon.svg';
import AgricultureIcon from '../../../assets/images/AgricultureIcon.svg';
import RecreationalIcon from '../../../assets/images/RecreationalIcon.svg';
import TransportationIcon from '../../../assets/images/TransportationIcon.svg';
import ExemptIcon from '../../../assets/images/ExemptIcon.svg';
import VacantLandIcon from '../../../assets/images/VacantLandIcon.svg';
import { getSavedPropertyList } from "data/search";
import { connect } from "react-redux";
import renderDateCell from "../../Search/Columns/renderDateCell";
import { Link, withRouter } from "react-router-dom";
import SVG from 'components/base/SVG';
import { SearchFields, SearchNames, SearchTables, PicViewFields, SearchTypes, SearchDataType, SearchFullTable, SearchLiensTable, SearchTypeCustom, SearchTypeDefault } from 'data/search';
import classNames from 'classnames';

import SaveIcon from '../../../assets/images/SaveIcon-Saved.svg'
import SaveHoverIcon from '../../../assets/images/SaveIcon-Hover.svg'
import NotSave from '../../../assets/images/SaveIcon-NotSaved.svg'

import { openGallery } from '../../Property/Gallery/GalleryPortalRenderer';
import ImageDefault from '../../../assets/images/Img.svg'
import ImageHover from '../../../assets/images/HoverImg.svg'
import RecentProperty from "../RecentProperty";

const ColumnsRenderers = {
    name: (props, sortIcon) => (
        <Column key="name" field="name">
            List Name {sortIcon}
        </Column>
    ),
    size: (props, sortIcon) => (
        <Column key="size" field="size">
            Property Count {sortIcon}
        </Column>
    ),
    updateDate: (props, sortIcon) => (
        <Column key="updateDate" field="updateDate" renderCell={renderDateCell}>
            Last Modified {sortIcon}
        </Column>
    ),
};

const CircularProgress = ({
    percentage = 0,
    size = 28,
    strokeWidth = 4,
    color = '#128292',
    backgroundColor = '#e0e0e0'
}) => {
    const isNegative = percentage < 0;
    const showDashed = percentage < -99;
    const absPercentage = Math.min(Math.abs(percentage), 100);

    const adjustedSize = size + strokeWidth;
    const radius = (size) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (absPercentage / 100) * circumference;

    let textValue = '';
    if (percentage < -99) {
        textValue = '--';
    } else if (percentage > 0) {
        textValue = `${Number.isInteger(percentage) ? percentage : percentage.toFixed(1)}`;
    } else {
        textValue = `${Number.isInteger(percentage) ? percentage : percentage.toFixed(1)}`;
    }

    return (
        <svg
            width={adjustedSize}
            height={adjustedSize}
            viewBox={`0 0 ${adjustedSize} ${adjustedSize}`}
            style={{ textAlign: "center" }}
        >
            {/* Background circle */}
            <circle
                stroke={backgroundColor}
                fill="none"
                strokeWidth={strokeWidth}
                cx={adjustedSize / 2}
                cy={adjustedSize / 2}
                r={radius}
            />

            {/* Progress circle */}
            {!showDashed && (
                <circle
                    stroke={isNegative ? 'red' : color}
                    fill="none"
                    strokeWidth={strokeWidth}
                    cx={adjustedSize / 2}
                    cy={adjustedSize / 2}
                    r={radius}
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    strokeLinecap="round"
                    transform={`rotate(${isNegative ? 90 : -90} ${adjustedSize / 2} ${adjustedSize / 2})`}
                />
            )}

            {/* Text value */}
            <text
                x="50%"
                y="50%"
                dy="1px"
                dominantBaseline="middle"
                textAnchor="middle"
                fontSize="11"
                fill={isNegative ? 'red' : color}
                fontWeight="800"
            >
                {textValue}
            </text>
        </svg>
    );
};

const propertyTypeIcons = {
    M: { src: OnMarket, alt: 'OnMarket', label: 'On Market' }, P: { src: PreForeclosures, alt: 'PreForeclosures', label: 'Pre-Foreclosures' }, A: { src: Auction, alt: 'Auctions', label: 'Auction' },
    F: { src: BankOwned, alt: 'BankOwned', label: 'Bank Owned' }, C: { src: CashBuyers, alt: 'CashBuyers', label: 'Cash Buyers' }, V: { src: Vacant, alt: 'Vacant', label: 'Vacant' },
    L: { src: Liens, alt: 'Liens', label: 'Liens' }, E: { src: HighEquity, alt: 'HighEquity', label: 'High Equity' }, D: { src: Divorce, alt: 'Divorce', label: 'Divorce' },
    B: { src: Bankruptcy, alt: 'Bankruptcy', label: 'Bankruptcy' }, Z: { src: FailedListings, alt: 'FailedListings', label: 'Failed Listings' }, I: { src: Flippers, alt: 'Flippers', label: 'Flippers' },
    R: { src: FreeClear, alt: 'FreeClear', label: 'Free & Clear' }, DEC: { src: PreProbate, alt: 'PreProbate', label: 'Pre-Probate' }, S: { src: SeniorOwners, alt: 'SeniorOwners', label: 'Senior Owners' },
    X: { src: TaxDelinquency, alt: 'TaxDelinquency', label: 'Tax Delinquency' }, T: { src: TiredLandlords, alt: 'TiredLandlords', label: 'Tired Landlords' }, UD: { src: UpsideLand, alt: 'UpsideLand', label: 'Upside Down' },
    VLN: { src: VacantLand, alt: 'VacantLand', label: 'Vacant Land' }, ZOM: { src: ZombieProperties, alt: 'ZombieProperties', label: 'Zombie Properties' },
};

const AdditionalLeadListModal = ({ isOpen, onClose, propertyId, displayResults, getSavedPropertyList, history, onSelect, onClick, index }) => {

    if (!isOpen || !propertyId) {
        return null;
    }
    const propertyData = displayResults.find(item => (item.get('id') || item.get("propertyId")) === propertyId);

    // Add a check here to handle the case where propertyData is not found
    if (!propertyData) {
        console.error("Property data not found for propertyId:", propertyId);
        return null; // or display a message, or handle the error gracefully
    }

    const [savedLists, setSavedLists] = useState(fromJS([]));

    const [sortConfig, setSortConfig] = useState({ key: null, ascending: true });
    const fields = ['name', 'size', 'updateDate'];

    const info = propertyData;

    let type = info.get('type');

    useEffect(() => {
        // setSavedLists(fromJS(data));
        if (propertyId) {
            console.log("Calling API for propertyId:", propertyId);
            getSavedPropertyList(propertyId, (response) => {
                console.log("API Response:", response.response);
                if (response) {
                    setSavedLists(fromJS(response.response));
                }
                else {
                    setSavedLists(fromJS([]));
                }
            });
        }
    }, [propertyId]);

    const initiallySelected = !!info.get('selected');
    const [isSelected, setIsSelected] = useState(initiallySelected);

    useEffect(() => {
        setIsSelected(!!info.get('selected'));
    }, [info]);

    const leadListMeta = {
        A: { label: 'Auctions', icon: Auction },
        B: { label: 'Bankruptcy', icon: Bankruptcy },
        C: { label: 'Cash Buyers', icon: CashBuyers },
        D: { label: 'Divorce', icon: Divorce },
        DEC: { label: 'Pre-Probate', icon: PreProbate },
        E: { label: 'High Equity', icon: HighEquity },
        F: { label: 'Bank Owned', icon: BankOwned },
        I: { label: 'Flippers', icon: Flippers },
        L: { label: 'Liens', icon: Liens },
        M: { label: 'On Market', icon: OnMarket },
        P: { label: 'Pre-Foreclosures', icon: PreForeclosures },
        R: { label: 'Free & Clear', icon: FreeClear },
        S: { label: 'Senior Owners', icon: SeniorOwners },
        T: { label: 'Tired Landlords', icon: TiredLandlords },
        UD: { label: 'Upside Down', icon: UpsideLand },
        V: { label: 'Vacant', icon: Vacant },
        VLN: { label: 'Vacant Land', icon: VacantLand },
        X: { label: 'Tax Delinquency', icon: TaxDelinquency },
        Z: { label: 'Failed Listings', icon: FailedListings },
        ZOM: { label: 'Zombie Properties', icon: ZombieProperties },
    };

    const defaultPropertyData = {
        price: "N/A",
        estimatedValue: "EST. VALUE",
        address: "Address not found.",
        beds: 'N/A',
        baths: 'N/A',
        sqft: 'N/A',
        lot: 'N/A',
        equity: 'N/A',
        loanBal: 'N/A',
        lastSale: 'N/A',
    };

    const address = info.get('address', Map());
    const cityName = address.get('cityName', '');
    const streetAddress = address.get('streetAddress', '');
    const propertyType = info.get('propertyType');
    const propertyClass = info.get('propertyClass');

    const formattedPropertyClass = (() => {
        if (!propertyClass) return '';

        const pretty = propertyClass.charAt(0).toUpperCase() + propertyClass.slice(1).toLowerCase();

        return propertyClass.toUpperCase() === 'VACANT' ? `${pretty} Land` : pretty;
    })();

    const landUse = info.get('landUse');
    const yearBuilt = info.get('yearBuilt');
    const bedrooms = info.get('bedrooms');
    const bathrooms = info.get('bathrooms');
    const squareFeet = info.get('squareFeet');
    const lotSquareFeet = info.get('lotSquareFeet');
    const addressString = `${streetAddress} ${cityName}`;
    const result = {};
    const saved = !!info.get('savedPropertyId');
    const code = info.get('propertyClassCode')

    const estimatedValue = info.get('estimatedValue');
    const [hoveredSaveId, setHoveredSaveId] = useState(null);
    const id = info.get('id');
    const groupName = info.getIn(['group', 'name']) || '';
    const groupId = info.getIn(['group', 'id']);
    const savedPropertyCount = info.get('savedPropertyCount');

    const [hoveredClassTagId, setHoveredClassTagId] = useState(null);

    const isItemSaved = (item) =>
        Boolean(item.get('savedPropertyId') || item.get('saved'));
    const savedNow = isItemSaved(info);

    const getIcon = (item) => {
        const hovering = hoveredSaveId === item.get('id');
        return isItemSaved(item) ? SaveIcon : (hovering ? SaveHoverIcon : NotSave);
    };

    const [showAddressTooltip, setShowAddressTooltip] = useState(false);
    const handleMouseEnterAddress = e =>
        setShowAddressTooltip(e.target.offsetWidth < e.target.scrollWidth);

    const lien = info.get('lien');
    const apartmentInfo = lien ? lien.set('type', 'LIEN') : info;
    let imageUrl = info.get('imageUrl');
    if (!imageUrl || imageUrl.includes('/coming_soon.') || imageUrl.includes('/house-img-not-available.')) imageUrl = "placeholder";

    const [isClicked, setIsClicked] = useState(false);

    const isFallbackImage =
        imageUrl === '' ||
        imageUrl.includes('coming_soon') ||
        imageUrl.includes('photo_coming_soon') ||
        imageUrl.includes('house-img-not-available') ||
        imageUrl.includes("placeholder")

    const updatedImageUrl = (() => {
        if (!imageUrl) return imageUrl;
        try {
            const url = new URL(imageUrl);
            const hostParts = url.hostname.split('.');

            if (
                hostParts.length === 4 &&
                hostParts[0] === 'images' &&
                hostParts[2] === 'propstream' &&
                hostParts[3] === 'com'
            ) {
                hostParts.splice(1, 1);
                url.hostname = hostParts.join('.');
            }

            return url.toString();
        } catch {
            return imageUrl;
        }
    })();

    const imageUrls = isFallbackImage
        ? '../../../assets/images/nophoto-searchtile.jpg'
        : updatedImageUrl;

    let propertyCardStyle = {
        backgroundImage: `url(${imageUrls})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
    };
    const link = `/search/${info.get('propertyId')}`;

    const street = info.getIn(['address', 'streetAddress']) || '';
    const city = info.getIn(['address', 'cityName']) || '';
    const state = info.getIn(['address', 'stateCode']) || '';
    const zip = info.getIn(['address', 'zip']) || '';

    const iconMap = {
        R: ResidentialIcon,
        C: CommercialIcon,
        O: OfficeIcon,
        I: IndustrialIcon,
        A: AgricultureIcon,
        F: RecreationalIcon,
        T: TransportationIcon,
        E: ExemptIcon,
        V: VacantLandIcon,
    };

    const propertyClassLabel = {
        R: 'Residential',
        C: 'Commercial',
        O: 'Office',
        I: 'Industrial',
        A: 'Agriculture',
        F: 'Recreational',
        T: 'Transportation',
        E: 'Exempt',
        V: 'Vacant Land',
    };

    const getLabelFromClassCode = (code) => propertyClassLabel[code];

    const isValid = (val) =>
        typeof val === 'string' &&
        val.trim() !== '' &&
        !val.includes('0000') &&
        !val.includes('00000') &&
        !val.includes('<No Street Address>') &&
        val.toLowerCase() !== 'undefined';

    let fAddress = '';

    if (isValid(street)) fAddress += street;

    if (isValid(city)) {
        if (fAddress) fAddress += ' ';
        fAddress += city;
    }

    const stateZip = [state, zip].filter(isValid).join(' ');
    if (stateZip) {
        if (fAddress) fAddress += ', ';
        fAddress += stateZip;
    }

    const fullAddress = isValid(state) && fAddress.trim() == state ? 'Address Unavailable' : fAddress || 'Address Unavailable';

    const handleSort = ({ fieldName }) => {
        setSortConfig(currentConfig => {
            if (currentConfig.key === fieldName) {
                if (currentConfig.ascending) {
                    return { ...currentConfig, ascending: false };
                }
                return { key: null, ascending: true };
            }
            return { key: fieldName, ascending: true };
        });
    };

    const sortedLists = useMemo(() => {
        if (!sortConfig.key) {
            return savedLists;
        }
        if (!savedLists || savedLists.isEmpty()) {
            return savedLists;
        }

        const sorted = savedLists.sortBy(item => item.get(sortConfig.key));
        return sortConfig.ascending ? sorted : sorted.reverse();
    }, [savedLists, sortConfig]);

    const handleRowClick = (event, row) => {
        const id = row.get('id');
        console.log('Row clicked, ID:', id);

        if (history && history.push) {
            history.push(`/property/group/${id}`);
        } else {
            window.location.assign(`/property/group/${id}`);
        }
    };

    const handleGalleryClick = (id) => {
        openGallery({ id: id });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} background="#F3F5F8"
            isCloseButton={false}
            uniqId="LeadListModal"
            width="auto"
            borderRadius="12px"
            modalClassName={css.LeadListModal}
            padding="0px"
        >
            <div className={css.modalContainer}>
                <div className={css.modalContent}>
                    <div className={css.proppertyBody}>
                        <div className={css.modalHeader}>
                            <h3 className={css.modalTitle}>Lists With This Property</h3>
                            <button onClick={onClose} className={css.closeButtonIcon}>
                                <img src={CloseBlack} alt="Close" className={css.closeIcon} />
                            </button>
                        </div>
                        <div className={css.propertyInfoCard} style={{
                            ...propertyCardStyle,
                            cursor: isSelected ? 'pointer' : 'default',
                        }}
                            onClick={() => onClick?.(info.get('id'), info)}
                            role="button"
                            tabIndex={0}>
                            <div className={css.cardBody}>
                                <div className={css.cardOverlay} >
                                    <div className={css.checkboxContainer}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                            <div className={css.checkboxWrapper}>
                                                <label className={css.checkboxContainer}>
                                                    <input
                                                        type="checkbox"
                                                        checked={isSelected}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setIsSelected(checked);
                                                            if (typeof onSelect === 'function') {
                                                                onSelect(info.get('id'), checked);
                                                            }
                                                        }}
                                                    />
                                                    <span className={css.checkmark}>
                                                        <svg viewBox="0 0 24 24" className={css.svgIcon}>
                                                            <path
                                                                d="M5 13L9.5 17.5L19 7"
                                                                fill="none"
                                                                stroke="#fff"
                                                                strokeWidth="2.5"
                                                                strokeLinecap="round"
                                                                strokeLinejoin="round"
                                                            />
                                                        </svg>
                                                    </span>
                                                </label>
                                            </div>

                                            {isSelected ? (
                                                <div className={css.indextag}>
                                                    <span className={css.indexspan}>{index}</span>
                                                </div>
                                            ) : (
                                                <div className={css.propertyTypeTag}>
                                                    <div className={css.headResult}>
                                                        <div className={css.tagParent}>
                                                            <div
                                                                className={`${css.tag} ${css.fadeInOut}`}
                                                                onClick={stopPropagation}
                                                                onMouseDown={stopPropagation}
                                                                onKeyDown={stopPropagation}
                                                                role="group"
                                                                onMouseEnter={() => setHoveredClassTagId(id)}
                                                                onMouseLeave={() => setHoveredClassTagId(null)}
                                                            >
                                                                <img
                                                                    src={iconMap[code] || ResidentialIcon}
                                                                    className={css.iconProperties}
                                                                    alt={info.propertyType || 'Property'}
                                                                />
                                                                <span className={css.res} style={{ height: '28px', padding: '7px 0' }}>
                                                                    {code ? `${getLabelFromClassCode(code)} - ${landUse}` : `${landUse}`}
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className={css.fadeChild}>
                                                            {!isSelected && (
                                                                <RecentProperty
                                                                    listName={groupName}
                                                                    count={savedPropertyCount}
                                                                    groupId={groupId}
                                                                    isIconHovered={hoveredClassTagId === id}
                                                                    redirectFlag={true} 
                                                                    disabled={false}
                                                                    />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        {(!isFallbackImage && !isSelected) && (
                                            <button
                                                className={`${css.imageIconButton} ${isClicked ? css.clicked : ''}`}
                                                onClick={e => { e.stopPropagation(); handleGalleryClick(id); }}
                                                onMouseDown={() => setIsClicked(true)}
                                                onMouseUp={() => setIsClicked(false)}
                                                onMouseLeave={() => setIsClicked(false)}
                                            >
                                                <img src={ImageDefault} alt="Default" className={`${css.imageIcon} ${css.imgDefaultIcon}`} />
                                                <img src={ImageHover} alt="Hover" className={`${css.imageIcon} ${css.imgHoverIcon}`} />
                                            </button>
                                        )}
                                    </div>
                                    <div className={css.propertyDetails}>
                                        <div className={css.priceContainer}>
                                            {info.get('onMarket') === true ? (
                                                <div className={css.priceSection}>
                                                    <span className={css.propertyValue}>{numberToPrice(info.getIn(['mlsListingAmount']))}</span>
                                                    <span className={css.estimatedValue}>LIST PRICE</span>
                                                </div>
                                            ) : (
                                                <div className={css.priceSection}>
                                                    <span className={css.propertyValue}>{numberToPrice(estimatedValue, 'N/A')}</span>
                                                    <span className={css.estimatedValue}>EST. VALUE</span>
                                                </div>
                                            )}

                                            <div
                                                className={classNames(css.tag, {
                                                    [css.hoverable]: !savedNow,
                                                    [css.disabled]: savedNow,
                                                })}
                                                aria-disabled={savedNow}
                                                onMouseEnter={!savedNow ? () => setHoveredSaveId(id) : undefined}
                                                onMouseLeave={!savedNow ? () => setHoveredSaveId(null) : undefined}
                                                onClick={!savedNow ? (e) => handleSaveClick(e, item) : undefined}
                                                style={savedNow ? { pointerEvents: 'none' } : undefined}
                                            >
                                                {(!savedNow && hoveredSaveId === id) && <span className={css.res}>Save</span>}
                                                <img
                                                    src={getIcon(info)}
                                                    className={css.iconProperties}
                                                    alt="Save"
                                                />
                                            </div>
                                        </div>
                                        <Link
                                            to={`/search/${info.get('id')}`}
                                            className={css.propertyAddress}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                onClick(info.get('id'), info);
                                            }}
                                            title={showAddressTooltip ? fullAddress : ''}
                                            onMouseEnter={handleMouseEnterAddress}
                                        >
                                            {fullAddress}
                                        </Link>
                                    </div>
                                </div>
                                <div className={css.cardBodyContainer}>

                                    <div className={css.propertyDetailsGrid}>
                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                            {[
                                                { value: bedrooms, icon: BedIcon, label: "" },
                                                { value: bathrooms, icon: Bath, label: "" },
                                                { value: squareFeet, icon: SqFt, label: "SQFT" },
                                                { value: lotSquareFeet, icon: LotSize, label: "LOT" }
                                            ]
                                                .filter(c => c.value)
                                                .map((c, index, arr) => (
                                                    <div
                                                        key={index}
                                                        style={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: "8px"
                                                        }}
                                                    >
                                                        {/* Icon + Text */}
                                                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                            <img
                                                                src={c.icon}
                                                                alt={c.label}
                                                                style={{ width: "20px", height: "20px" }}
                                                            />
                                                            <span className={css.iconCounts}>
                                                                {numberFormat(c.value)}
                                                                {(c.label === "SQFT" || c.label === "LOT") && (
                                                                    <span
                                                                        style={{
                                                                            color: "#3C4654",
                                                                            fontSize: "14px",
                                                                            fontFamily: "Inter",
                                                                            fontWeight: 700,
                                                                            position: "relative",
                                                                            fontStyle: "normal",
                                                                            lineHeight: "14px",
                                                                            textTransform: "uppercase"
                                                                        }}
                                                                    >
                                                                        {c.label}
                                                                    </span>
                                                                )}
                                                            </span>

                                                        </div>

                                                        {/* Separator */}
                                                        {index !== arr.length - 1 && (
                                                            <div
                                                                style={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    gap: "8px"
                                                                }}
                                                            >
                                                                <div
                                                                    style={{
                                                                        width: "1px",
                                                                        height: "20px",
                                                                        backgroundColor: "#DFE1E4"
                                                                    }}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                        </div>
                                    </div>
                                    <div className={css.footer}>
                                        {(PicViewFields[type] || PicViewFields[SearchTypeCustom]).map(({ type, value, label }, index) => {
                                            const field = SearchFields[value];
                                            let val = info.get(field);

                                            if (val || val === 0) {
                                                if (type === SearchDataType.DATE) val = formatDate(val, null, null, info.get(`${field}Format`));
                                                else if (type === SearchDataType.PRICE) val = numberToPrice(val);
                                            } else if (info.get('type') !== 'O') val = 0;
                                            else if (info.get('type') === "O") val = null

                                            const propertyType = info.get('type');
                                            const estimatedValue = info.get('estimatedValue');
                                            const estimatedEquity = info.get('estimatedEquity');

                                            let equityPercentage = 0;
                                            if (info.has('equityPercentage')) {
                                                const estEquityPercentage = info.get('equityPercentage');
                                                equityPercentage = estEquityPercentage;
                                            } else {
                                                if (estimatedValue != null && estimatedEquity != null) {
                                                    const estValue = parseFloat(estimatedValue);
                                                    const estEquity = parseFloat(estimatedEquity);

                                                    if (estValue > 0 && estEquity >= 0) {
                                                        equityPercentage = Math.round((estEquity / estValue) * 100);
                                                    }
                                                }
                                            }

                                            if (!val && val !== 0 && !(index === 0 && propertyType === 'O')) {
                                                return (
                                                    <div className={classNames(css.field, css.firstFieldNoValue)}>
                                                    </div>
                                                );
                                            }

                                            return (
                                                <div className={classNames(css.field, { [css.hidden]: val == null || val === '', [css.firstFieldNoValue]: (!val || val === 0), })}>
                                                    <div>
                                                        {index === 0 && (
                                                            propertyType === 'O' ? (
                                                                <CircularProgress percentage={equityPercentage} />
                                                            ) : propertyTypeIcons[propertyType] ? (
                                                                <div className={css.leadlistContainer}>
                                                                    <div className={css.imageTrigger}>
                                                                        <img src={propertyTypeIcons[propertyType].src} alt={propertyTypeIcons[propertyType].alt} style={{ width: '24px', height: '30px' }} />
                                                                    </div>
                                                                    <div className={css.leadlist}>
                                                                        <span>Lead List : {propertyTypeIcons[propertyType].label}</span>
                                                                    </div>
                                                                </div>
                                                            ) : null
                                                        )}
                                                        <div>
                                                            {val && val !== 0 ? (
                                                                <div className={css.fieldSet}>
                                                                    <span className={css.title}>
                                                                        {label.length > 14 ? `${label}` : label}
                                                                    </span>
                                                                    <span className={css.value} title={String(val)}>
                                                                        {label === 'Sale Price'
                                                                            ? `${String(val).slice(0, 11)}${String(val).length > 11 ? '...' : ''} ${isNDAState(info.getIn(['address', 'stateCode'])) ? 'EST.' : ''}`
                                                                            : (String(val).length > 11 ? `${String(val).slice(0, 11)}...` : val)
                                                                        }
                                                                    </span>
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={css.propertyInfoDivider} />

                        <div className={css.tableContainer}>
                            <Table
                                data={sortedLists}
                                sortFields={fromJS(sortConfig.key ? [sortConfig.key] : [])}
                                onColumnSort={handleSort}
                                onRowClick={handleRowClick}
                                keyField="id"
                                className="type_11"
                                isSortable
                                isHoverable
                            >
                                {fields.map(field => {
                                    const isSorting = sortConfig.key === field;
                                    const sortIcon = isSorting ? (
                                        <SVG icon={`iconCaret${sortConfig.ascending ? 'Up' : 'Down'}`} className={css.sortIcon} />
                                    ) : null;
                                    return ColumnsRenderers[field]({}, sortIcon);
                                })}
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    );
};

const mapDispatchToProps = {
    getSavedPropertyList,
};

export default withRouter(connect(null, mapDispatchToProps)(AdditionalLeadListModal));